import EmptySettings from '@/components/addConnector/EmptySettings.vue'
export default EmptySettings
